import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CheckParentComponent } from './check-parent.component';
import { Observable, of} from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable()

export class CheckParentModalService {
  constructor(
    private modal: BsModalService,
  ) { 
  }
  open():Observable<boolean> {
    const modal:BsModalRef = this.modal.show(CheckParentComponent, {}); 
    return modal.content.action.pipe(
      take(1),
    )
  }
}
